import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import styles from './subscriptionSummary.scss';

// Single source of truth for the "Enrolled: Power {Monthly|Annual} Plan / price / renewal date"
// summary (TMS-2338 deliverable 9). Extracted verbatim from the SubscriptionsPageV2 enrolled-plan
// card so the Subscriptions page and the off-page Update-CC modal render the identical block. Data is
// the already-resolved power subscription plus the member's billing interval — no new fetch. The
// caller supplies the `data-testid` prefix; the page keeps its original suffixes.
const SubscriptionSummary = ({ subscription, isMonthly, isAppleSubscriber, 'data-testid': dataTestId }) => {
    const { displayAmount, renewalDate, isCancelled } = subscription || {};
    return (
        <>
            <div className={styles.cardHeader}>
                <i className={`utr utr-check-circle ${styles.checkIcon}`} data-testid={dataTestId && `${dataTestId}.enrolled-icon`} />
                <span data-testid={dataTestId && `${dataTestId}.enrolled-plan`}>Enrolled: Power {isMonthly ? 'Monthly' : 'Annual'} Plan</span>
            </div>
            {!isAppleSubscriber && (
                <div className={styles.planPrice} data-testid={dataTestId && `${dataTestId}.plan-price`}>
                    {displayAmount}{isMonthly ? '/Month' : ''}
                    {!isMonthly && <span className={styles.bestValue} data-testid={dataTestId && `${dataTestId}.plan-best-value`}> BEST VALUE</span>}
                </div>
            )}
            {renewalDate && !isAppleSubscriber && (
                <div className={styles.renewalDate} data-testid={dataTestId && `${dataTestId}.renewal-date`}>
                    {isCancelled ? 'Subscription End Date' : 'Renewal Date'}: <strong>{moment(renewalDate).format('MMM D, YYYY')}</strong>
                </div>
            )}
            {isAppleSubscriber && (
                <div className={styles.appleManagedMessage} data-testid={dataTestId && `${dataTestId}.apple-message`}>
                    <p data-testid={dataTestId && `${dataTestId}.apple-message-text`}>
                        Your subscription is managed by Apple.
                        To make changes, open the UTR Sports app on your iPhone or iPad,
                        or go to Apple Settings → Subscriptions.
                    </p>
                </div>
            )}
        </>
    );
};

SubscriptionSummary.propTypes = {
    subscription: PropTypes.shape({
        displayAmount: PropTypes.string,
        renewalDate: PropTypes.string,
        isCancelled: PropTypes.bool,
    }),
    isMonthly: PropTypes.bool,
    isAppleSubscriber: PropTypes.bool,
    'data-testid': PropTypes.string,
};

SubscriptionSummary.defaultProps = {
    subscription: null,
    isMonthly: false,
    isAppleSubscriber: false,
    'data-testid': null,
};

export default SubscriptionSummary;
